export const ACTION_BUTTON_TYPE = {
  PRIMARY: 'primary',
  SECONDARY: 'secondary',
  FULL_WIDTH: 'full-width',
  TERTIARY: 'tertiary'
};
